import type { BadgeTone } from '@artosera/ui';
import type { EtatFacture } from '../../api/ventes.js';

/**
 * Teinte de pastille par état de facture (même esprit que
 * `oeuvres/statutUi.ts` et `expositions/etatUi.ts`) : le libellé exact vient
 * toujours de `ventes:factures.<etat>` (espace de noms partagé) ; cette table
 * ne choisit que la couleur.
 */
const TEINTE_PAR_ETAT: Record<EtatFacture, BadgeTone> = {
  brouillon: 'neutral',
  emise: 'reserved',
  payee: 'available',
  annulee: 'withdrawn',
};

export function teinteDeLEtatFacture(etat: EtatFacture): BadgeTone {
  return TEINTE_PAR_ETAT[etat];
}

/** États dans l'ordre du filtre de la liste. */
export const ETATS_FACTURE_TRIES: readonly EtatFacture[] = [
  'brouillon',
  'emise',
  'payee',
  'annulee',
];
